module.exports = __webpack_public_path__ + "img/6.1734d79b.png";